import {Inject, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {RestService, RestSimpleResponseParser, RestYiiFilterService, RestYiiPagination, RestYiiSort} from 'gelios-ng-admin-components';
import {HttpClient} from '@angular/common/http';

// import {HttpClient} from '@angular/common/http';

@Injectable()
export class UnitService <T> extends RestService <T> {

  public get url(): string {
    return environment.apiBasepoint + 'unit';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this.expand = [
      'unitModel',
      'hwModel',
      'unitType',
      'lastMsgUnit',
      'attachedTrackerLastMsgUnit',
      'unitModel.project',
      'speed',
      'sats',
      'gsm',
      'height',
      'unitStatus',
      'businessLogic',
      'business_logic_custom_name',
      'executor',
      'executor.currentEmployee',
      'billings',
      'hasBillings',
      'next_maintenance',
      'unit_group_ids_names',
      'owner',
      'rentToIntegrator',
    ].join(',');
    this._filter.searchModelName = 'UnitSearch';
  }
}
